/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import Card from '../../misc-components/Card';
import SortOptions from '../../misc-components/SortOptions';

import CurriculumGames from '../../data/curriculum-games.json';

const CurriculumGamePage = ({
  setCurriculumPopUp
}) => {
  const user = JSON.parse(localStorage.getItem('profile'));
  const [games, setGames] = useState([]);
  const sortOptions = [
    {value: 'new'},
    {value: 'old'},
    {value: 'nameDesc'},
    {value: 'nameAsc'},
    {value: 'gradeAsc'},
    {value: 'gradeDesc'}
  ];
  const [sortName, setSortName] = useState('');

  useEffect(() => {
    setSortName('new')
    addGames();
  }, [])

  useEffect(() => {
    sortGames();
  }, [sortName]);

  function addGames() {
    let newGames = CurriculumGames.curriculum_games;

    for (let i = 0; i < newGames.length; i++) {
      newGames.id = i;
      newGames.toolState = false;
    }

    setGames(newGames);
  }

  function changeCardState (index, state) {
    let newCards = [...games];

    newCards[index].toolState = state;
    setGames(newCards);
  }

  function handleSortChange (event) {
    setSortName(event.target.value)
  }

  function sortGames() {
    if (sortName === sortOptions[0].value) {
      sortNewest();
    } else if (sortName === sortOptions[1].value) {
      sortOldest();
    } else if (sortName === sortOptions[2].value) {
      sortNameDesc();
    } else if (sortName === sortOptions[3].value) {
      sortNameAsc();
    } else if (sortName === sortOptions[4].value) {
      sortGradesAsc();
    } else if (sortName === sortOptions[5].value) {
      sortGradesDesc();
    }
  }

  function sortNewest() {
    let newCards = [...games];

    setGames(newCards.sort((a, b) => new Date(b.date) - new Date(a.date )));
  }

  function sortOldest() {
    let newCards = [...games];
    setGames(newCards.sort((a, b) => new Date(a.date) - new Date(b.date) ));
  }

  function sortCompare(a, b) {
    const titleA = a.title.toUpperCase();
    const titleB = b.title.toUpperCase();

    let compareNumber = 0;
    if (titleA > titleB) {
      compareNumber = 1;
    } else if (titleA < titleB) {
      compareNumber = -1;
    }
    return compareNumber;
  }

  function sortCompareAsc(a, b) {
    const titleA = a.title.toUpperCase();
    const titleB = b.title.toUpperCase();

    let compareNumber = 0;
    if (titleA > titleB) {
      compareNumber = -1;
    } else if (titleA < titleB) {
      compareNumber = 1;
    }
    return compareNumber;
  }

  function sortNameAsc() {
    let newCards = [...games];

    newCards.sort(sortCompareAsc);

    setGames(newCards);
  }

  function sortNameDesc() {
    let newCards = [...games];

    newCards.sort(sortCompare);

    setGames(newCards);
  }

  function sortGradesDesc() {
    let newCards = [...games];

    setGames(newCards.sort((a, b) => b.grade - a.grade));
  }

  function sortGradesAsc() {
    let newCards = [...games];

    setGames(newCards.sort((a, b) => a.grade - b.grade));
  }

  return (
    <div className='container-fluid game_container_background py-4'>
      <div className='container align-items-center'>
        <div className='d-flex flex-column'>
          <div className='game-container d-flex align-items-center justify-content-between'>
            <div>
              <p className='game-title-text'>Curriculum Games</p>
            </div>
            <SortOptions
              handleSortChange={handleSortChange}
              sortName={sortName}
            />
          </div>
          <div className='tool-grid row align-items-center justify-content-center'>
            {games.map((game, index) => (
              <>
              {
                game.isPopUp === true && (game.usernameReqs === undefined || game.usernameReqs.findIndex((username) => username === user?.result.username) >= 0) ?
                <div
                  onClick={() => {setCurriculumPopUp()}}
                >
                  <Card
                    isCurriculum={true}
                    onMouseEnter={() => changeCardState(index, true)}
                    onMouseLeave={() => changeCardState(index, false)}
                    link={''}
                    backgroundImage={game.imageURL}
                    hoverState={game.toolState}
                    title={game.title}
                    grade={game.grade}
                    gradeClass={game.gradeClass}
                    endGrade={game.endGrade}
                  />
                </div>
                : game.isPopUp === true ?
                null :
                <Card
                  isCurriculum={true}
                  onMouseEnter={() => changeCardState(index, true)}
                  onMouseLeave={() => changeCardState(index, false)}
                  link={game.link}
                  backgroundImage={game.imageURL}
                  hoverState={game.toolState}
                  title={game.title}
                  grade={game.grade}
                  gradeClass={game.gradeClass}
                  endGrade={game.endGrade}
                />
              }
              </>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CurriculumGamePage;